module.exports = __webpack_public_path__ + "img/discord02.a7a904d.jpg";